// extracted by mini-css-extract-plugin
export default {"link":"NewsweekContinueListeningLink_link__LxBwO","iconContainer":"NewsweekContinueListeningLink_iconContainer__EXblZ","text":"NewsweekContinueListeningLink_text__x3Qnw"};